import React, { useState } from 'react';
import Datetime from 'react-datetime';
import moment from 'moment';
import "../../assets/css/purchase/form.css";
import { formatDateCheque } from '../../utils/DateUtils';

const DatePicker = ({ label, name, value, onChange, disabled }) => {
    const [showCalendar, setShowCalendar] = useState(false);

    return (
        <>
            <div className="d-flex align-items-center">
                {label && (
                    <label htmlFor={name} className="form-label">{label}</label>
                )}
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control input-spacing"
                        disabled={true}
                        name={name}
                        placeholder={formatDateCheque(value) || "กรุณาระบุวันที่"}
                        style={{ width: '240px' }}
                    />
                    <button
                        className="btn btn-outline-secondary"
                        onClick={() => setShowCalendar(!showCalendar)}
                        disabled={disabled}
                        style={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            height: '100%',
                            padding: '0 10px'
                        }}
                    >
                        <i className="fas fa-calendar"></i>
                    </button>
                </div>
            </div>
            {showCalendar && (
                <Datetime
                    className="input-spacing-input-date"
                    name={name}
                    value={value ? moment(value).format('YYYY-MM-DD') : null}
                    dateFormat="YYYY-MM-DD"
                    onChange={(date) => {
                        onChange(date, name);
                        setShowCalendar(false);
                    }}
                    timeFormat={false}
                    open={showCalendar}
                    inputProps={{
                        hidden: true,
                    }}
                />
            )}
        </>
    );
};

export default DatePicker;